var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "org-tree-container"
  }, [_c("div", {
    staticClass: "org-tree",
    class: {
      horizontal: _vm.horizontal,
      collapsable: _vm.collapsable
    }
  }, [_c("org-tree-node", {
    attrs: {
      data: _vm.data,
      props: _vm.props,
      horizontal: _vm.horizontal,
      "label-width": _vm.labelWidth,
      collapsable: _vm.collapsable,
      "render-content": _vm.renderContent,
      "label-class-name": _vm.labelClassName,
      "selected-class-name": _vm.selectedClassName,
      "selected-key": _vm.selectedKey
    },
    on: {
      "on-expand": (e, data) => _vm.$emit("on-expand", e, data),
      "on-node-focus": (e, data) => _vm.$emit("on-node-focus", e, data),
      "on-node-click": (e, data) => _vm.$emit("on-node-click", e, data),
      "on-node-mouseover": (e, data) => _vm.$emit("on-node-mouseover", e, data),
      "on-node-mouseout": (e, data) => _vm.$emit("on-node-mouseout", e, data),
      "on-node-drag-start": (e, data) => _vm.onDragStart(e, data),
      "on-node-drag-over": (e, data) => _vm.onDragOver(e, data),
      "on-node-drop": (e, data) => _vm.onDrop(e, data)
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };